module.exports = __webpack_public_path__ + "media/fonts/materialdesignicons-webfont-e9db4005489e24809b62e61177c543a8.woff2";